// extracted by mini-css-extract-plugin
export default {"description-container":"fJlKWA"};